@if (loading()) {
  <cmi-loading-spinner />
} @else {
  @if (anyUnavailable()) {
    <cmi-notification
      class="block w-full text-left"
      mode="error"
      [message]="'uploadSuccess.errorLoad' | translate"
      [actionLabel]="'uploadSuccess.retry' | translate"
      (actionClick)="onReload()" />
  }

  @for (entry of entries(); track $index) {
    <dl class="w-full rounded-xl border border-cmi-gray-light bg-white p-3 text-left">
      <dt class="text-xs font-medium tracking-wide text-cmi-gray-mid uppercase">
        {{ 'uploadSuccess.dossierLabel' | translate }}
      </dt>
      <dd class="truncate text-sm font-medium text-cmi-gray">
        @if (!entry.dossier) {
          <span class="text-cmi-gray-mid italic">
            {{ 'uploadSuccess.dossierUnavailable' | translate }}
          </span>
        } @else if (entry.dossierLink; as link) {
          <a
            [href]="link"
            target="_blank"
            rel="noopener noreferrer"
            class="text-main hover:underline">
            {{ entry.dossier.titel }}
          </a>
        } @else {
          {{ entry.dossier.titel }}
        }
      </dd>

      @if (entry.dossier) {
        <dt class="mt-3 text-xs font-medium tracking-wide text-cmi-gray-mid uppercase">
          {{ 'uploadSuccess.folderLabel' | translate }}
        </dt>
        <dd class="truncate text-sm font-medium text-cmi-gray">
          @if (entry.inRoot) {
            {{ 'uploadSuccess.dossierRoot' | translate }}
          } @else if (!entry.folderPath) {
            <span class="text-cmi-gray-mid italic">
              {{ 'uploadSuccess.folderUnavailable' | translate }}
            </span>
          } @else if (entry.folderLink; as link) {
            <a
              [href]="link"
              target="_blank"
              rel="noopener noreferrer"
              class="text-main hover:underline">
              {{ entry.folderPath }}
            </a>
          } @else {
            {{ entry.folderPath }}
          }
        </dd>
      }

      <dt class="mt-3 text-xs font-medium tracking-wide text-cmi-gray-mid uppercase">
        {{ 'uploadSuccess.filedAtLabel' | translate }}
      </dt>
      <dd class="text-sm font-medium text-cmi-gray">{{ entry.filedAt }}</dd>
    </dl>
  }
}
